import { REGEX_EMAIL_FORMAT } from 'constants/regex';

export const isValidEmail = (email: string | undefined): boolean => {
  return !!email?.trim() && !!email!.match(REGEX_EMAIL_FORMAT);
};
